// Photos en attente d'opérations annulées sans avoir été envoyées (élément créé puis supprimé sur l'appareil…)
export const cleanupRemovedOps = async (services, removedOps) => {
    const photoIds = removedOps.filter(op => op.type === 'photo.upload').map(op => op.target.id);
    if (photoIds.length) await services.db.photos.bulkDelete(photoIds);
};
